import metrics from 'maps/metrics';
import { ITableHeader } from '../shared/types';

export default getTableHeaders;

function getTableHeaders(): ITableHeader[] {
  return [
    { ...metrics['countryName'] },
    { label: '30 DAY TREND', value: 'trend', key: 'trend' },
    {
      ...metrics['countLastWeek'],
      label: 'Last\nfull week',
      change: undefined,
    },
    { ...metrics['wow_last_completed'], value: 'wowLastCompleted' },
    { label: 'expand', value: 'expand', key: 'expand' },
  ];
}

export function getMenuItems(heads: ITableHeader[]): any {
  const menuItems: any = {};

  heads.forEach((head: ITableHeader) => {
    if (head.key === 'countryName') {
      menuItems[head.key] = [
        {
          label: `${head.label} (A-Z)`,
          sortMetric: head.key,
          sortOrder: 'asc',
        },
        {
          label: `${head.label} (Z-A)`,
          sortMetric: head.key,
          sortOrder: 'desc',
        },
      ];
    } else {
      menuItems[head.key] = [
        {
          label: 'High to Low',
          sortMetric: head.key,
          sortOrder: 'desc',
        },
        {
          label: 'Low to High',
          sortMetric: head.key,
          sortOrder: 'asc',
        },
      ];
    }
  });

  return menuItems;
}
